var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.996,
    height: 49.997,
    viewBox: "0 0 49.996 49.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.07,
    x2: 0.5,
    y2: 0.93,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42d778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#3dca76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34b171"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    transform: "translate(-378 -2685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M55.451,12H14.545A4.545,4.545,0,0,0,10,16.545V57.451A4.545,4.545,0,0,0,14.545,62H55.451A4.545,4.545,0,0,0,60,57.451V16.545A4.545,4.545,0,0,0,55.451,12Z",
    transform: "translate(368 2673)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M46.7,24.706,30.363,41.039l-7.248-7.246a2.409,2.409,0,0,0-3.407,0l0,0a2.407,2.407,0,0,0,0,3.405l8.731,8.728a2.725,2.725,0,0,0,3.853,0L50.11,28.113a2.407,2.407,0,0,0,0-3.405l0,0A2.409,2.409,0,0,0,46.7,24.706Z",
    transform: "translate(369.226 2674.635)",
    fill: "#f1fcff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.5e1920f9df5384c92f8a23d8e6908e54.svg";
export { ForwardRef as ReactComponent };